import e, { createContext as t, useContext as r, useEffect as n, useState as i, useRef as o } from "react";

function a(e, t) {
  var r, n;
  if ("function" == typeof t) void 0 !== (n = t(e)) && (e = n);else if (Array.isArray(t)) for (r = 0; r < t.length; r++) {
    void 0 !== (n = t[r](e)) && (e = n);
  }
  return e;
}

function c(e, t) {
  return "-" === e[0] && Array.isArray(t) && /^-\d+$/.test(e) ? t.length + parseInt(e, 10) : e;
}

function l(e) {
  return "[object Object]" === Object.prototype.toString.call(e);
}

function u(e) {
  return Object(e) === e;
}

function s(e) {
  return 0 === Object.keys(e).length;
}

function f(e, t) {
  return e.indexOf("[") >= 0 && (e = e.replace(/\[/g, ".").replace(/]/g, "")), e.split(t);
}

function p(e, t, r) {
  if (!(this instanceof p)) return new p(e, t, r);
  void 0 === t && (t = !1), void 0 === r && (r = !0), this.separator = e || ".", this.override = t, this.useArray = r, this.keepArray = !1, this.cleanup = [];
}

var h = new p(".", !1, !0);

function y(e) {
  return function () {
    return h[e].apply(h, arguments);
  };
}

p.prototype._fill = function (e, t, r, n) {
  var i = e.shift();

  if (e.length > 0) {
    if (t[i] = t[i] || (this.useArray && function (e) {
      return /^\d+$/.test(e);
    }(e[0]) ? [] : {}), !u(t[i])) {
      if (!this.override) {
        if (!u(r) || !s(r)) throw new Error("Trying to redefine `" + i + "` which is a " + typeof t[i]);
        return;
      }

      t[i] = {};
    }

    this._fill(e, t[i], r, n);
  } else {
    if (!this.override && u(t[i]) && !s(t[i])) {
      if (!u(r) || !s(r)) throw new Error("Trying to redefine non-empty obj['" + i + "']");
      return;
    }

    t[i] = a(r, n);
  }
}, p.prototype.object = function (e, t) {
  var r = this;
  return Object.keys(e).forEach(function (n) {
    var i = void 0 === t ? null : t[n],
        o = f(n, r.separator).join(r.separator);
    -1 !== o.indexOf(r.separator) ? (r._fill(o.split(r.separator), e, e[n], i), delete e[n]) : r.override && (e[n] = a(e[n], i));
  }), e;
}, p.prototype.str = function (e, t, r, n) {
  return -1 !== e.indexOf(this.separator) ? this._fill(e.split(this.separator), r, t, n) : r.hasOwnProperty(e) && !this.override || (r[e] = a(t, n)), r;
}, p.prototype.pick = function (e, t, r) {
  var n, i, o, a, l;

  for (i = f(e, this.separator), n = 0; n < i.length; n++) {
    if (a = c(i[n], t), !(t && "object" == typeof t && a in t)) return;
    if (n === i.length - 1) return r ? (o = t[a], delete t[a], Array.isArray(t) && (l = i.slice(0, -1).join("."), -1 === this.cleanup.indexOf(l) && this.cleanup.push(l)), o) : t[a];
    t = t[a];
  }

  return r && Array.isArray(t) && (t = t.filter(function (e) {
    return void 0 !== e;
  })), t;
}, p.prototype.remove = function (e, t) {
  var r;

  if (this.cleanup = [], Array.isArray(e)) {
    for (r = 0; r < e.length; r++) {
      this.pick(e[r], t, !0);
    }

    return this._cleanup(t), t;
  }

  return this.pick(e, t, !0);
}, p.prototype._cleanup = function (e) {
  var t, r, n, i;

  if (this.cleanup.length) {
    for (r = 0; r < this.cleanup.length; r++) {
      t = (t = (i = (n = this.cleanup[r].split(".")).splice(0, -1).join(".")) ? this.pick(i, e) : e)[n[0]].filter(function (e) {
        return void 0 !== e;
      }), this.set(this.cleanup[r], t, e);
    }

    this.cleanup = [];
  }
}, p.prototype.del = p.prototype.remove, p.prototype.move = function (e, t, r, n, i) {
  return "function" == typeof n || Array.isArray(n) ? this.set(t, a(this.pick(e, r, !0), n), r, i) : (i = n, this.set(t, this.pick(e, r, !0), r, i)), r;
}, p.prototype.transfer = function (e, t, r, n, i, o) {
  return "function" == typeof i || Array.isArray(i) ? this.set(t, a(this.pick(e, r, !0), i), n, o) : (o = i, this.set(t, this.pick(e, r, !0), n, o)), n;
}, p.prototype.copy = function (e, t, r, n, i, o) {
  return "function" == typeof i || Array.isArray(i) ? this.set(t, a(JSON.parse(JSON.stringify(this.pick(e, r, !1))), i), n, o) : (o = i, this.set(t, this.pick(e, r, !1), n, o)), n;
}, p.prototype.set = function (e, t, r, n) {
  var i, o, a, c;
  if (void 0 === t) return r;

  for (a = f(e, this.separator), i = 0; i < a.length; i++) {
    if (c = a[i], i === a.length - 1) {
      if (n && l(t) && l(r[c])) for (o in t) {
        t.hasOwnProperty(o) && (r[c][o] = t[o]);
      } else if (n && Array.isArray(r[c]) && Array.isArray(t)) for (var u = 0; u < t.length; u++) {
        r[a[i]].push(t[u]);
      } else r[c] = t;
    } else r.hasOwnProperty(c) && (l(r[c]) || Array.isArray(r[c])) || (/^\d+$/.test(a[i + 1]) ? r[c] = [] : r[c] = {});
    r = r[c];
  }

  return r;
}, p.prototype.transform = function (e, t, r) {
  return t = t || {}, r = r || {}, Object.keys(e).forEach(function (n) {
    this.set(e[n], this.pick(n, t), r);
  }.bind(this)), r;
}, p.prototype.dot = function (e, t, r) {
  return t = t || {}, r = r || [], Object.keys(e).forEach(function (n) {
    if (u(e[n]) && (l(e[n]) && !s(e[n]) || Array.isArray(e[n]) && !this.keepArray && 0 !== e[n].length)) return this.dot(e[n], t, r.concat(n));
    t[r.concat(n).join(this.separator)] = e[n];
  }.bind(this)), t;
}, p.pick = y("pick"), p.move = y("move"), p.transfer = y("transfer"), p.transform = y("transform"), p.copy = y("copy"), p.object = y("object"), p.str = y("str"), p.set = y("set"), p.del = p.remove = y("remove"), p.dot = y("dot"), ["override", "overwrite"].forEach(function (e) {
  Object.defineProperty(p, e, {
    get: function get() {
      return h.override;
    },
    set: function set(e) {
      h.override = !!e;
    }
  });
}), ["useArray", "keepArray"].forEach(function (e) {
  Object.defineProperty(p, e, {
    get: function get() {
      return h[e];
    },
    set: function set(t) {
      h[e] = t;
    }
  });
}), p._process = a;
var d = p,
    v = t({
  initialData: {},
  errors: {},
  scopePath: "",
  registerField: function registerField() {},
  unregisterField: function unregisterField() {}
});

function m(e) {
  var t = r(v),
      i = t.initialData,
      o = t.errors,
      a = t.scopePath,
      c = t.unregisterField,
      l = t.registerField,
      u = a ? a + "." + e : e;
  n(function () {
    return function () {
      return c(u);
    };
  }, [u]);
  var s = d.pick(u, i),
      f = o[u];
  return {
    fieldName: u,
    registerField: l,
    defaultValue: s,
    error: f
  };
}

var _b = function b() {
  return (_b = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var i in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function g(e, t) {
  var r = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;

    for (n = Object.getOwnPropertySymbols(e); i < n.length; i++) {
      t.indexOf(n[i]) < 0 && (r[n[i]] = e[n[i]]);
    }
  }

  return r;
}

function A(e, t) {
  var r,
      n,
      i,
      o,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & i[0]) throw i[1];
      return i[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;

  function c(o) {
    return function (c) {
      return function (o) {
        if (r) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

            switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
              case 0:
              case 1:
                i = o;
                break;

              case 4:
                return a.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                a.label++, n = o[1], o = [0];
                continue;

              case 7:
                o = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                  a = 0;
                  continue;
                }

                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                  a.label = o[1];
                  break;
                }

                if (6 === o[0] && a.label < i[1]) {
                  a.label = i[1], i = o;
                  break;
                }

                if (i && a.label < i[2]) {
                  a.label = i[2], a.ops.push(o);
                  break;
                }

                i[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            o = t.call(e, a);
          } catch (e) {
            o = [6, e], n = 0;
          } finally {
            r = i = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, c]);
    };
  }
}

function k(t) {
  var r = t.initialData,
      n = void 0 === r ? {} : r,
      o = t.children,
      a = t.schema,
      c = t.context,
      l = void 0 === c ? {} : c,
      u = t.onSubmit,
      s = i({}),
      f = s[0],
      p = s[1],
      h = i([]),
      y = h[0],
      m = h[1];

  function b() {
    y.forEach(function (e) {
      var t = e.ref,
          r = e.path,
          n = e.clearValue;
      return n ? n(t) : d.set(r, "", t);
    });
  }

  return e.createElement(v.Provider, {
    value: {
      initialData: n,
      errors: f,
      scopePath: "",
      registerField: function registerField(e) {
        m(function (t) {
          return t.concat([e]);
        });
      },
      unregisterField: function unregisterField(e) {
        m(y.filter(function (t) {
          return t.name !== e;
        }));
      }
    }
  }, e.createElement("form", {
    "data-testid": "form",
    onSubmit: function onSubmit(e) {
      return t = this, r = void 0, i = function i() {
        var t, r, n;
        return A(this, function (i) {
          switch (i.label) {
            case 0:
              e.preventDefault(), t = function () {
                var e = {};
                return y.forEach(function (t) {
                  var r = t.name,
                      n = t.ref,
                      i = t.path,
                      o = t.parseValue,
                      a = d.pick(i, n);
                  e[r] = o ? o(a) : a;
                }), d.object(e), e;
              }(), i.label = 1;

            case 1:
              return i.trys.push([1, 4,, 5]), a ? [4, a.validate(t, {
                abortEarly: !1,
                stripUnknown: !0,
                context: l
              })] : [3, 3];

            case 2:
              i.sent(), t = a.cast(t, {
                stripUnknown: !0,
                context: l
              }), i.label = 3;

            case 3:
              return p({}), u(t, {
                resetForm: b
              }), [3, 5];

            case 4:
              if (r = i.sent(), n = {}, !r.inner) throw r;
              return r.inner.forEach(function (e) {
                n[e.path] = e.message;
              }), p(n), [3, 5];

            case 5:
              return [2];
          }
        });
      }, new ((n = void 0) || (n = Promise))(function (e, o) {
        function a(e) {
          try {
            l(i.next(e));
          } catch (e) {
            o(e);
          }
        }

        function c(e) {
          try {
            l(i.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function l(t) {
          t.done ? e(t.value) : new n(function (e) {
            e(t.value);
          }).then(a, c);
        }

        l((i = i.apply(t, r || [])).next());
      });
      var t, r, n, i;
    }
  }, o));
}

function w(t) {
  var n = t.path,
      i = t.children,
      o = r(v),
      a = o.scopePath,
      c = g(o, ["scopePath"]);
  return e.createElement(v.Provider, {
    value: _b({}, c, {
      scopePath: a.concat(a ? "." + n : n)
    })
  }, i);
}

function E(t) {
  var r = t.name,
      i = t.label,
      a = g(t, ["name", "label"]),
      c = o(null),
      l = m(r),
      u = l.fieldName,
      s = l.registerField,
      f = l.defaultValue,
      p = l.error;
  return n(function () {
    c.current && s({
      name: u,
      ref: c.current,
      path: "value"
    });
  }, [c.current, u]), e.createElement(e.Fragment, null, i && e.createElement("label", {
    htmlFor: u
  }, i), e.createElement("input", _b({}, a, {
    ref: c,
    id: u,
    name: u,
    "aria-label": u,
    defaultValue: f
  })), p && e.createElement("span", null, p));
}

function O(t) {
  var r = t.name,
      i = t.label,
      a = g(t, ["name", "label"]),
      c = o(null),
      l = m(r),
      u = l.fieldName,
      s = l.registerField,
      f = l.defaultValue,
      p = l.error;
  return n(function () {
    c.current && s({
      name: u,
      ref: c.current,
      path: "value"
    });
  }, [c.current, u]), e.createElement(e.Fragment, null, i && e.createElement("label", {
    htmlFor: u
  }, i), e.createElement("textarea", _b({}, a, {
    ref: c,
    id: u,
    name: u,
    "aria-label": u,
    defaultValue: f
  })), p && e.createElement("span", null, p));
}

function j(t) {
  var r = t.name,
      i = t.label,
      a = t.options,
      c = g(t, ["name", "label", "options"]),
      l = o(null),
      u = m(r),
      s = u.fieldName,
      f = u.registerField,
      p = u.defaultValue,
      h = u.error;
  return n(function () {
    l.current && f({
      name: s,
      ref: l.current,
      path: "value"
    });
  }, [l.current, s]), e.createElement(e.Fragment, null, i && e.createElement("label", {
    htmlFor: s
  }, i), e.createElement("select", _b({}, c, {
    multiple: !1,
    id: s,
    name: s,
    defaultValue: p,
    "aria-label": s,
    ref: l
  }), e.createElement("option", {
    value: ""
  }, "Selecione..."), a.map(function (t) {
    var r = t.id,
        n = t.title;
    return e.createElement("option", {
      key: r,
      value: r
    }, n);
  })), h && e.createElement("span", null, h));
}

export { k as Form, E as Input, w as Scope, j as Select, O as Textarea, m as useField };